<template>
    <GraphicDesignRequest></GraphicDesignRequest>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const GraphicDesignRequest = defineAsyncComponent(() =>
    import("../../components/Design/GraphicDesignRequest.vue")
);

export default {
    name: "GraphicDesignRequestForm", //The name you are in should not equal the name of the component you are importing.
    components: { GraphicDesignRequest, AuthLayout },
};
</script>
